import { useEffect, useRef } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

const MapComponent = ({ location, radius, onRadiusChange, onLocationChange }) => {
    const map = useMap();
    const circleRef = useRef(null);

    // Create circle once when the map instance is ready.
    // location/radius are read from the closure at init time; subsequent changes
    // are applied imperatively by the two effects below — no teardown needed.
    useEffect(() => {
        if (!map || !location) return;

        circleRef.current = new window.google.maps.Circle({
            strokeColor:   '#4f46e5',
            strokeOpacity: 0.85,
            strokeWeight:  2,
            fillColor:     '#4f46e5',
            fillOpacity:   0.12,
            center:    location,
            radius:    radius,
            map:       map,
            editable:  true,
            draggable: true,
        });

        circleRef.current.addListener('radius_changed', () => {
            onRadiusChange(circleRef.current.getRadius());
        });

        circleRef.current.addListener('center_changed', () => {
            const c = circleRef.current.getCenter();
            onLocationChange({ lat: c.lat(), lng: c.lng() });
        });

        return () => {
            if (circleRef.current) {
                window.google.maps.event.clearInstanceListeners(circleRef.current);
                circleRef.current.setMap(null);
                circleRef.current = null;
            }
        };
    }, [map]); // eslint-disable-line react-hooks/exhaustive-deps

    // Update radius imperatively — circle is not recreated
    useEffect(() => {
        if (!circleRef.current) return;
        circleRef.current.setRadius(radius);
    }, [radius]);

    // Update center imperatively — circle is not recreated
    useEffect(() => {
        if (!circleRef.current) return;
        circleRef.current.setCenter(location);
    }, [location]);

    return null;
};

export default MapComponent;
